// ==============================|| OVERRIDES - FormLabel ||============================== //

export default function FormLabel() {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#262626',
        },
      },
    },
  };
}
